import { Entity } from '@pinup-teams/common';

export interface Course extends Entity {
  lmsCourseId: number;
  name: string;
}

export interface GetCoursesReq {
  courses: Course[];
}
